import { AbstractCommand } from 'src/models/command';

class UpdateTheUserPreferenceCommand extends AbstractCommand {
	readonly name = 'IFS_Core_Command_Commands_UpdateTheUserPreferenceCommand';

	public constructor(key: string, value: string) {
		super();
		this.parameters = {
			key,
			value,
		};
	}
}

export { UpdateTheUserPreferenceCommand };
